(() => {
  const script = document.querySelector('[data-pdp-revenue-experiment]');
  if (!script || script.dataset.enabled !== 'true') return;

  const config = {
    experimentId: script.dataset.experimentId,
    productHandle: script.dataset.productHandle,
    template: script.dataset.template,
    currentTemplate: script.dataset.currentTemplate || '',
    productVariantIds: JSON.parse(script.dataset.productVariantIds || '[]').map(Number)
  };

  const assignmentKey = `vs:${config.experimentId}:assignment`;
  const exposureKey = `vs:${config.experimentId}:${config.productHandle}:exposure`;
  const isVariantB = config.currentTemplate === config.template;
  let experimentInitialized = false;

  const analyticsAllowed = () => (
    window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true
  );

  const canonicalUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('view');
    return url;
  };

  const redirectTo = (variant) => {
    const url = canonicalUrl();
    if (variant === 'B') url.searchParams.set('view', config.template);
    window.location.replace(url.toString());
  };

  const publish = (name, payload) => {
    if (!analyticsAllowed()) return;
    window.Shopify?.analytics?.publish?.(`dj_supply:${name}`, payload);
  };

  const createAssignment = () => ({
    variant: crypto.getRandomValues(new Uint8Array(1))[0] < 128 ? 'A' : 'B',
    assignmentId: crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`
  });

  const initializeExperiment = () => {
    if (experimentInitialized) return;

    if (!analyticsAllowed()) {
      if (isVariantB) redirectTo('A');
      return;
    }

    let assignment;
    try {
      assignment = JSON.parse(localStorage.getItem(assignmentKey)) || createAssignment();
      if (!['A', 'B'].includes(assignment.variant) || !assignment.assignmentId) assignment = createAssignment();
      localStorage.setItem(assignmentKey, JSON.stringify(assignment));
    } catch (error) {
      assignment = { variant: 'A', assignmentId: '' };
    }

    if ((assignment.variant === 'B') !== isVariantB) {
      redirectTo(assignment.variant);
      return;
    }

    experimentInitialized = true;
    const eventPayload = {
      experiment_id: config.experimentId,
      variant: assignment.variant,
      product_handle: config.productHandle,
      assignment_id: assignment.assignmentId
    };

    try {
      if (sessionStorage.getItem(exposureKey) !== assignment.variant) {
        publish('experiment_exposure', eventPayload);
        sessionStorage.setItem(exposureKey, assignment.variant);
      }
    } catch (error) {
      publish('experiment_exposure', eventPayload);
    }

    let cartAttributionWritten = false;
    document.addEventListener('on:cart:add', async (event) => {
      if (!analyticsAllowed()) return;
      if (cartAttributionWritten || !config.productVariantIds.includes(Number(event.detail?.variantId))) return;
      cartAttributionWritten = true;
      publish('product_added_to_cart', eventPayload);

      try {
        await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              vs_pdp_experiment: [
                config.experimentId,
                assignment.variant,
                config.productHandle,
                assignment.assignmentId
              ].join('|')
            }
          })
        });
      } catch (error) {
        // Cart attribution is a measurement aid and must never block ordering.
      }
    });
  };

  document.addEventListener('visitorConsentCollected', initializeExperiment);

  if (window.Shopify?.customerPrivacy) {
    initializeExperiment();
    return;
  }

  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (!error) initializeExperiment();
      }
    );
    return;
  }

  if (isVariantB) redirectTo('A');
})();
